/**
 * Check whether input is a valid number or not
 * @param value, string or number
 * @returns boolean
 */
export default function (value: string | number): boolean {
  if (value == null) {
    return false;
  }

  if (typeof value === 'number') return true;

  const parsedValue = parseFloat(value);

  return !isNaN(parsedValue) && isFinite(parsedValue);
}
